import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import {
  FooterSection,
  Title,
  LogoContainer,
  Para,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {

  return (
    <FooterSection>
      <Container>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "1rem" }}>
          {/* <Col lg={12} md={12} sm={12} xs={24}> */}
          <LogoContainer style={{ display: "flex", alignItems: "center", gap: "0.65rem" }}>
            <SvgIcon src="logo_footer.svg" width="32px" height="32px" />
            <Title style={{ fontSize: "1.1rem", margin: 0 }}>
              <span style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 300, color: "rgba(237,242,255,0.45)" }}>My</span>
              <span style={{ fontFamily: "'Fraunces', Georgia, serif", fontWeight: 700, color: "#E8A020" }}>Exam</span>
              <span style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 500, color: "rgba(237,242,255,0.9)" }}>Nation</span>
            </Title>
          </LogoContainer>

          {/* </Col> */}
          {/* <Col lg={12} md={12} sm={12} xs={24}> */}
          <Para>
            &copy; {new Date().getFullYear()} MyExamNation. Helping Malaysians prepare for banking and finance exams, one question at a time.
          </Para>
          {/* </Col> */}
        </div>
      </Container>
    </FooterSection >
  );
};

export default withTranslation()(Footer);